import { AccountMenu } from '@components/App/AccountMenu'
import type { ScheduleDto } from '@octopus-do/octopus-api-client'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import {
  DownloadButtonMenu,
  ProjectMenu,
  ScheduleButton,
  SettingsMenu,
  Share,
  UpdateButton,
} from './components'
import css from './styles.module.css'

interface Props {
  canEdit: boolean
  crawling: boolean
  onRecrawl: () => void
  onScheduled: () => void
  schedule: ScheduleDto | null
  updatedAt: null | string
}

export const Header: React.FC<Props> = ({
  canEdit,
  crawling,
  onRecrawl,
  onScheduled,
  schedule,
  updatedAt,
}) => {
  const updated = updatedAt ? `Updated ${updatedAt}` : ''

  // A signed-out reader has no dashboard to go back to, so the project menu is
  // not offered — the account button next to it is what invites them in.
  const authenticated = useSelector<AppState, boolean>(
    ({ auth }) => auth.authenticated
  )

  return (
    <div className={css.header}>
      {authenticated && <ProjectMenu />}

      <div className={css.left_column}>
        {/* When the report was crawled goes with the button that crawls it. */}
        {canEdit && (
          <div className={css.update_text}>
            {crawling ? 'Updating…' : updated}
          </div>
        )}
        <div className={css.buttons}>
          {canEdit && (
            <>
              <UpdateButton crawling={crawling} onClick={onRecrawl} />
              <ScheduleButton onScheduled={onScheduled} schedule={schedule} />
              <Share />
            </>
          )}
          <DownloadButtonMenu />
        </div>
        <div className={css.settings}>
          <SettingsMenu
            onRecrawl={onRecrawl}
            onScheduled={onScheduled}
            schedule={schedule}
          />
        </div>
        <AccountMenu />
      </div>
    </div>
  )
}
